<template>
	<div>
		<div class="header-content">
			<img :src="getImage()"/>
			<div class="header-menu">
				<p class="text">{{$t('myProfile')}}</p>
				<p>{{$t('hi')}}, {{userName}}</p>
			</div>
		</div>
	</div>
</template>
<script>
import { Vue } from 'vue-property-decorator'
import auth from '@/config/auth'
export default class HeaderProfile extends Vue {
	userName = this.$store.state.user.name

	getImage(){
		const user = auth.currentUser
		if (user != null) {
			return user.photoURL
		}
	}
}
</script>
<style lang="scss" scoped>
p {
	margin: 0;
}
.header-content {
	display: flex;
	padding: 1em;
	border: 1px solid #dadada;
	img {
		width: 81px;
		height: 81px;
		border-radius: 150px;
		background-image: url("~@/assets/img/beebot.png");
		background-size: cover;
		background-repeat: no-repeat;
	}
	.header-menu {
		padding: 1em;
		p {
			color: rgba(254, 202, 56, 1);
			font-weight: 700;
			font-size: 1.8em;
		}
		.text {
			font-size: 16px;
			color: rgba(0, 0, 0, 1);
		}
	}
}
</style>